import { Booking } from 'components/EventCalendar/types';
import { Form } from 'components/Form/base/Form';
import { FormInput } from 'components/Form/next';
import Loader from 'components/Loader';
import { usePaymentStatus } from 'components/MollieConnect/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../../hooks/useApi';

interface Props {
    booking: Booking;
    callback?: (data: Booking) => void;
}

export const CancellationForm = ({ booking, callback }: Props) => {
    const api = useApi();
    const { t } = useTranslation('bookings');
    const { data, error } = usePaymentStatus(booking.payment_id);
    const [isLoading, setIsLoading] = useState(false);
    const isLoadingPayment = booking.payment_id && !data && !error;
    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `booking/${booking.id}/cancel`,
            method: 'POST',
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback?.(data)
        });
    };

    const amountRemaining = Number(data?.amountRemaining?.value);
    // The field is only rendered for a refundable online payment. Seeding it unconditionally would
    // submit a full-amount refund for a field the user never saw, which then credits the whole invoice.
    const canRefund = !!booking.payment_id && amountRemaining > 0;

    return (
        <Loader isLoading={isLoadingPayment}>
            <Form
                onSubmit={handleSubmit}
                setDefaultValuesOnRerender={false}
                // Rest statt Gesamtbetrag: nach einer Teilerstattung ist der volle Betrag nicht mehr
                // erstattbar, und die Vorbelegung liefe gegen die Obergrenze des Feldes
                defaultValues={canRefund ? { payment_refund_value: amountRemaining } : {}}
            >
                <FormInput.Textarea name="reason" label={t('booking.cancellation.reasonLabel')} />
                {canRefund && (
                    <FormInput
                        type="number"
                        step={0.01}
                        max={amountRemaining}
                        name="payment_refund_value"
                        label={t('booking.cancellation.refundValueLabel', {
                            amount: data?.amount?.value,
                            currency: data?.amount?.currency
                        })}
                    />
                )}
                <FormInput.Submit isLoading={isLoadingPayment || isLoading} color="error">
                    {t('booking.cancellation.submit')}
                </FormInput.Submit>
            </Form>
        </Loader>
    );
};
